import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { getWorkoutPlan } from 'store/workouts/actions';

import { useSelector } from 'hooks';

const toISODateString = (date: Date): string => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
};

export const useGetWorkoutPlan = () => {
    const dispatch = useDispatch();
    const [selectedDate, setSelectedDate] = useState(new Date());
    const { plan, isLoading } = useSelector((state) => state.workouts);

    useEffect(() => {
        dispatch(getWorkoutPlan(toISODateString(selectedDate)));
    }, [dispatch, selectedDate]);

    return { plan, isLoading, selectedDate, setSelectedDate };
};
